'use client';

import Slider from 'react-slick';
import styled, { css, keyframes } from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Children, type ReactNode, useState } from 'react';

export const MultipleRolling = ({
  children,
  onActiveIndexChange,
  animationnDuration = 3000,
}: {
  children: ReactNode[];
  onActiveIndexChange: (index: number) => void;
  animationnDuration?: number;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState<number | null>(null);

  const settings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: animationnDuration,
    beforeChange: (current: number, next: number) => {
      setPrevIndex(current);
      setCurrentIndex(next);
      onActiveIndexChange(next);
    },
    dots: false,
    pauseOnHover: false,
    slidesToShow: 1,
    swipe: false,
    useTransform: true,
    vertical: true,
  };

  if (children.length === 0) {
    return null;
  }
  if (children.length < 2) {
    return <ListItem>{children[0]}</ListItem>;
  }
  const childArray = Children.toArray(children);
  return (
    <Container {...settings}>
      {childArray.map((child, index) => (
        <ListItem
          key={
            typeof child === 'object' && 'key' in child && child.key != null
              ? child.key
              : `rolling-item-${index}`
          }
          $isActive={index === currentIndex}
          $isPrevActive={index === prevIndex}
        >
          {child}
        </ListItem>
      ))}
    </Container>
  );
};

const moveIn = keyframes`
  from {
    transform: translateY(50%);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
`;

const moveOut = keyframes`
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(-50%);
    opacity: 0;
  }
`;

const Container = styled(Slider)`
  .slick-slide {
    border: none !important;
  }
`;

const ListItem = styled.div<{
  $isActive?: boolean;
  $isPrevActive?: boolean;
}>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      animation: ${moveIn} 0.3s ease-in-out;
    `}
  ${({ $isPrevActive }) =>
    $isPrevActive &&
    css`
      animation: ${moveOut} 0.3s ease-in-out;
    `}
`;
